// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| OVERRIDES - DATA GRID ||============================== //

export default function DataGrid(theme) {
  const schemeTheme = theme.colorSchemes;
  return {
    MuiDataGrid: {
      defaultProps: {
        rowHeight: 54
      },
      styleOverrides: {
        root: {
          borderWidth: 0,

          '& .MuiDataGrid-columnHeader--filledGroup': {
            borderBottomWidth: 0
          },

          '& .MuiDataGrid-columnHeader--emptyGroup': {
            borderBottomWidth: 0
          },

          // Fix for spurious scrollbar in the pagination/footer area
          // Targets the internal ScrollbarSize measuring div
          '& div[aria-hidden="true"]': {
            '&[style*="overflow: scroll"], &[style*="overflow:scroll"]': {
              display: 'none',
              width: '0 !important',
              height: '0 !important'
            }
          },

          '& .MuiFormControl-root>.MuiInputBase-root': {
            backgroundColor: `${theme.vars.palette.background.default} !important`,
            borderColor: `${theme.vars.palette.divider} !important`,

            ...theme.applyStyles('dark', {
              borderColor: `${withAlpha(theme.vars.palette.divider, 0.05)} !important`
            })
          }
        },
        withBorderColor: {
          borderColor: theme.vars.palette.divider,

          ...theme.applyStyles('dark', {
            borderColor: schemeTheme.dark?.palette.divider ? withAlpha(schemeTheme.dark.palette.divider, 0.15) : undefined
          })
        },
        toolbarContainer: {
          '& .MuiButton-root': {
            paddingLeft: '16px !important',
            paddingRight: '16px !important'
          }
        },
        columnHeader: {
          color: theme.vars.palette.grey[600],
          paddingLeft: 24,
          paddingRight: 24
        },
        footerContainer: {
          minHeight: 'auto',
          '&.MuiDataGrid-withBorderColor': {
            borderBottom: 'none'
          },
          '& .MuiTablePagination-root': {
            minHeight: 'auto'
          },
          '& .MuiTablePagination-toolbar': {
            minHeight: 'auto',
            padding: '0px !important'
          }
        },
        columnHeaderCheckbox: {
          paddingLeft: 0,
          paddingRight: 0
        },
        cellCheckbox: {
          paddingLeft: 0,
          paddingRight: 0
        },
        cell: {
          borderWidth: 1,
          paddingLeft: 24,
          paddingRight: 24,
          borderColor: theme.vars.palette.divider,

          '&.MuiDataGrid-cell--withRenderer > div': {
            ' > .high': {
              background: theme.vars.palette.success.light
            },
            '& > .medium': {
              background: theme.vars.palette.warning.light
            },
            '& > .low': {
              background: theme.vars.palette.error.light
            },

            ...theme.applyStyles('dark', {
              color: theme.vars.palette.grey[50],

              ' > .high': {
                background: theme.vars.palette.success.dark
              },
              '& > .medium': {
                background: theme.vars.palette.warning.dark
              },
              '& > .low': {
                background: theme.vars.palette.error.dark
              }
            })
          },

          ...theme.applyStyles('dark', {
            borderColor: schemeTheme.dark?.palette.divider ? withAlpha(schemeTheme.dark.palette.divider, 0.15) : undefined
          })
        }
      }
    }
  };
}
